import { useQuery } from '@tanstack/react-query';
import { useActivePage } from '@toolpad/core';
import { useParams } from 'react-router';
import { Stack } from '@mui/material';

import { QueryRenderer } from '@barboxx/admin-components';
import Api from '@barboxx/api';
import { Can } from '@barboxx/react-utils';

import { RootContainer } from '../../components/nav/RootContainer';
import { ProductCategoryDeleteCard } from './components/ProductCategoryDeleteCard';
import { ProductCategoryDetailsCard } from './components/ProductCategoryDetailsCard';
import { ProductTypesCard } from './components/ProductTypesCard';

export function ProductCategoryDetails() {
    const { id } = useParams();
    const activePage = useActivePage();

    const productCategoryQueryResults = useQuery({
        queryKey: ['productCategory', id],
        queryFn: () => Api.Products.Categories.getProductCategory(Number(id)),
    });

    const breadcrumbs = [
        ...(activePage?.breadcrumbs ?? []),
        {
            title: 'Dashboard',
            path: `/`,
        },
        {
            title: 'Product Categories',
            path: `/products/categories`,
        },
        {
            title: 'Details',
            path: `products/categories/${id}`,
        },
    ];

    return (
        <RootContainer maxWidth="md" breadcrumbs={breadcrumbs} title="Details">
            <QueryRenderer results={productCategoryQueryResults}>
                {data => (
                    <Stack gap={2} sx={{ paddingBottom: 4 }}>
                        <ProductCategoryDetailsCard productCategory={data} />
                        <ProductTypesCard
                            productCategory={data}
                            refetch={productCategoryQueryResults.refetch}
                        />

                        {!data.types.length && (
                            <Can I="delete" a="ProductCategory">
                                <ProductCategoryDeleteCard
                                    productCategory={data}
                                />
                            </Can>
                        )}
                    </Stack>
                )}
            </QueryRenderer>
        </RootContainer>
    );
}
